<script setup lang="ts">

</script>

<template>
<div class="bg-slate-800 py-1 px-2">
  <slot></slot>
</div>
</template>

<style scoped lang="scss">

</style>